<template>
  <div class="control_bar top">
    <div class="search">
      <input
        type="text"
        class="search_field"
        placeholder="管理者名から検索"
        v-model="inputValue"
      />
      <input
        type="button"
        :value="search"
        class="search_button"
        @click="adminAccountFindAction"
      />
    </div>
    <controller
      :dispItems="dispItems"
      :allItems="adminAccounts"
      :router="router"
      @remove="remove"
      @exportFile="exportFile"
    >
    </controller>
    <div class="false_modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      search: '検索',
      showFinishModal: false,
      finishWord: '',
      router: '/adminAccounts/add',
      showloadingModal: false,
      confirmed: ''
    }
  },
  computed: {
    adminAccounts() {
      return this.$store.state.adminAccounts.adminAccounts
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    selectedAccountList() {
      return this.$store.state.adminAccounts.selectedAccountList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow
  },
  async mounted() {
    var uploader = document.getElementById('uploader')
    uploader.setAttribute('disabled', 'disabled')
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showFinishModal = false
    },
    async remove(e) {
      this.showloadingModal = true
      let selectedAccountList = []
      for (let i = 0; i < this.selectedAccountList.length; i++) {
        let adminUserId = this.selectedAccountList[i].adminUserId
        selectedAccountList.push({adminUserId})
        if (e[i].authority === 'マスター管理者') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_290010
          let eventType = 3
          let reason = 'MSGCRC0074 '
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0074.name +
            this.errorMsg.MSGCRC0074.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
      }
      try {
        await this.$store.dispatch(
          'adminAccounts/deleteAdminAccounts',
          selectedAccountList
        )
        this.$store.dispatch('adminAccounts/clearSelectedAccountList')
        this.finishWord = '対象の管理者を削除しました。'
        this.showFinishModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        if (location.pathname !== '/adminAccounts') {
          this.$router.push('/adminAccounts')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_290003
        let eventType = 3
        let reason = 'MSGCRC0072 '
        if (error.response) {
          this.finishWord =
            this.errorMsg.MSGCRC0072.name +
            this.errorMsg.MSGCRC0072.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    adminAccountFindAction(event) {
      this.$emit('input-event', 0, this.inputValue)
      this.confirmed = this.inputValue
    },
    async importFile(e) {},
    async exportFile() {
      var selectedAccountIdList = this.selectedAccountList.map(account => {
        return {adminUserId: account.adminUserId}
      })
      this.showloadingModal = true
      try {
        const params = {selectedAccountIdList: selectedAccountIdList}
        if (selectedAccountIdList.length === 0) {
          params.searchWord = this.confirmed ? this.confirmed : ''
        }
        await this.$store.dispatch('adminAccounts/setExportData', params)

        const exportList = this.$store.state.adminAccounts.exportData
        let result = this.$store.state.error.exportTitle.adminAccountTitle
        for (let i = 0; i < exportList.length; i++) {
          for (let k of Object.keys(exportList[i])) {
            if (!exportList[i][k]) {
              exportList[i][k] = ''
            }
          }
          result +=
            exportList[i].adminUserId +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].adminUserName) +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].mailAddress) +
            ',' +
            exportList[i].authority +
            '\r\n'
        }
        if (result === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_290008
          let eventType = 9
          let reason = 'MSGCRC0006'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0006.name +
            this.errorMsg.MSGCRC0006.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        let csv = ''
        csv += result
        let link = document.createElement('a')
        let bom = new Uint8Array([0xef, 0xbb, 0xbf])
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csv], {type: 'text/csv'})
          window.navigator.msSaveOrOpenBlob(blob, '管理者ユーザー一覧.csv')
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', '管理者ユーザー一覧.csv')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', '管理者ユーザー一覧.csv')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_290005
          let eventType = 9
          let reason = 'MSGCRC0007'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0007.name +
            this.errorMsg.MSGCRC0007.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_290006
        let eventType = 3
        let reason = ''
        if (error.response) {
          reason = 'MSGCRC0073 '
          this.finishWord =
            this.errorMsg.MSGCRC0073.name +
            this.errorMsg.MSGCRC0073.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    },
    exportSetDoubleQuotation(value) {
      let c = ''
      let s = ''
      let doubleQuoteFlg = false
      // ダブルクォーテーションのエスケープ処理
      for (let i = 0; i < value.length; i++) {
        c = value.charAt(i)
        if (c === '"') {
          doubleQuoteFlg = true
          s = s + '"' + c
        } else {
          s = s + c
        }
      }
      if (doubleQuoteFlg) {
        s = '"' + s + '"'
      }
      // カンマがある場合、ダブルクォーテーションで囲む
      if (s.indexOf(',') >= 0 && !doubleQuoteFlg) {
        return '"' + s + '"'
      }
      return s
    }
  }
}
</script>

<style scoped>
.controller >>> .txt,
.controller >>> .column_import {
  color: #bbb;
  pointer-events: none;
}
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/adminAccounts/controlbar.vue